export default {
  Posted: 1,
  NotPosted: 0,
};
